<div class="card shadow-none border-0">
  <div class="card-body p-0">
    <div class="my-5 text-center">
      <div class="d-flex justify-content-center align-items-center">
        <div class="spinner-border spinner-border-sm" role="status">
          <span class="sr-only"></span>
        </div>
        <div class="pl-2">
          {{ message }}
        </div>
      </div>

      <div class="mt-2" *ngIf="showRefresh">
        This page automatically refreshes every {{ refreshInterval }} seconds.

        <a class="text-primary" (click)="refresh.emit()">
          Refresh Now
        </a>
      </div>
    </div>
  </div>
</div> 